export const PPR_TOKEN_COOKIE = 'pprToken';
export const INTERMEDIARY_TOKEN_COOKIE = 'intermediaryToken';
